var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBath(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7086 13.4219H10.6155V14.1994H11.7086V13.4219Z",
    fill: "#505565"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.08772 13.4219H1.99463V14.1994H3.08772V13.4219Z",
    fill: "#505565"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.631104 11.9944C0.631104 12.5128 1.04805 12.9297 1.56642 12.9297H12.1254C12.6438 12.9297 13.0607 12.5128 13.0607 11.9944V8.625H0.631104V11.9944Z",
    fill: "#505565"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.37774 6.64867V1.08182C2.37774 0.800094 2.63693 0.563446 2.95246 0.563446C3.22291 0.563446 3.44829 0.73248 3.51591 0.957859L3.04261 1.43115C2.96373 1.51004 2.94119 1.63399 2.98627 1.73541C3.0088 1.80303 3.06515 1.8481 3.12149 1.88191L2.77216 2.53551C2.69327 2.67074 2.74962 2.83977 2.88485 2.91865C2.92992 2.94119 2.975 2.95246 3.02007 2.95246C3.12149 2.95246 3.22291 2.89611 3.26799 2.80596L3.53844 2.29886V2.86231C3.53844 3.02007 3.6624 3.14403 3.82017 3.14403C3.97793 3.14403 4.10189 3.02007 4.10189 2.86231V2.29886L4.37234 2.80596C4.42869 2.89611 4.51884 2.95246 4.62026 2.95246C4.66534 2.95246 4.71041 2.94119 4.75549 2.91865C4.89071 2.83977 4.94706 2.67074 4.86818 2.53551L4.51884 1.88191C4.57518 1.8481 4.63153 1.80303 4.65407 1.73541C4.69914 1.63399 4.67661 1.51004 4.59772 1.43115L4.09062 0.924052C4.00047 0.405681 3.52717 0 2.95246 0C2.3214 0 1.8143 0.484564 1.8143 1.08182V6.64867H0V8.05728H13.7143V6.64867H2.37774Z",
    fill: "#505565"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBath);
export default __webpack_public_path__ + "static/media/Bath.d594adede778128d897062f665c3e30f.svg";
export { ForwardRef as ReactComponent };